export const FACEBOOK = 'fb';
export const GOOGLE = 'gl';
export const SALESFORCE = 'sf';
export const ZENDESK = 'zd';
